import React from "react";
import api from "../../utils/api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const ContactForm = ({nameOfStore}) => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);

  const [formData, setFormData] = React.useState({
    fullName: "",
    phone: "",
    email: "",
    message: "",
    termsAccepted: false,
  });

  const [errors, setErrors] = React.useState({
    fullName: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevData) => ({ ...prevData, [name]: checked }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const validateForm = () => {
    let isValid = true;
    let errors = {};

    // Full Name Validation
    if (!formData.fullName.trim()) {
      errors.fullName = "Full name is required.";
      isValid = false;
    }

    // Phone Number Validation (simple regex for phone number)

  

    // Email Validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!formData.email.match(emailRegex)) {
      errors.email = "Please enter a valid email address.";
      isValid = false;
    }

    // Message Validation
    if (!formData.message.trim()) {
      errors.message = "Message is required.";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form before submission
    if (!validateForm()) {
      toast.error("Please fill all the fields correctly.");
      return;
    }

    const payload = {
      userId: user._id, // Replace this with the actual user ID, if dynamic
      name: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      inquiryType: "Order Issue",
      message: formData.message,
      paymentId: null, // Optional, set dynamically if needed
      refundStatus: null, // Optional, set dynamically if needed
      status: null, // Default status
      resolvedAt: null, // Default to null
    };
    console.log("🚀 ~ handleSubmit ~ payload:", payload);

    try {
      const response = await api.post("/support-query", payload); // Send directly without stringify

      console.log("🚀 ~ handleSubmit ~ response:", response);

      // Check for successful status code
      if (response.status !== 201) {
        throw new Error("Failed to submit the form.");
      }

      toast.success("Your message has been sent successfully!", {
        style: {
          backgroundColor: "white", // Background color
          color: "#AD343E", // Text color
        },
        icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
      });
      // Optionally reset the form fields
      setFormData({
        fullName: "",
        phone: "",
        email: "",
        message: "",
        termsAccepted: false,
      });
    } catch (error) {
      console.error("🚀 ~ handleSubmit ~ error:", error); // Log the error for debugging
      toast.error("There was an error submitting your message. Please try again.");
    }
  };

  return (
    <>
      <section className="mt-32 flex flex-col md:flex-row justify-center items-center space-y-8 md:space-y-0 md:space-x-8">
        {/* Left side with text "Connect" and "FoodGlance" */}
        <div className="flex-1 text-center md:text-left">
          <div className="w-full">
            <p className="body font-medium text-3xl md:text-5xl leading-tight md:leading-[88px] text-[#321D1D]">
              <span>Connect</span>
              <br />
              <span>with {nameOfStore}!</span>
            </p>
          </div>
        </div>

        {/* Right side with form */}
        <div className="w-full max-w-3xl mx-auto p-6 flex-1">
       <div className= "w-full flex justify-center items-center">
       <button className="my-6 body text-3xl font-bold text-[#AF313D]  rounded-full  hover:bg-red-700 ">
          Ask A Question
        </button>
       </div>
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* First Row: Full Name and Phone Number */}
            <div className="flex flex-col md:flex-row md:space-x-6 space-y-4 md:space-y-0">
              <div className="flex-1">
                <label
                  htmlFor="full-name"
                  className="block body text-sm font-medium text-gray-700"
                >
                  Full Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  id="full-name"
                  className="mt-1 body block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#AF313D]"
                  placeholder="Your Full Name"
                />
                {errors.fullName && (
                  <span className="text-red-500 text-xs">{errors.fullName}</span>
                )}
              </div>
              <div className="flex-1">
                <label
                  htmlFor="phone"
                  className="block body text-sm font-medium text-gray-700"
                >
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="mt-1 body block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#AF313D]"
                  placeholder="Your Phone Number"
                />
                {errors.phone && (
                  <span className="text-red-500 text-xs">{errors.phone}</span>
                )}
              </div>
            </div>

            {/* Second Row: Email Address */}
            <div>
              <label
                htmlFor="email"
                className="block  body text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 block body w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#AF313D]"
                placeholder="Your Email Address"
              />
              {errors.email && (
                <span className="text-red-500 text-xs">{errors.email}</span>
              )}
            </div>

            {/* Last Field: Your Message */}
            <div>
              <label
                htmlFor="message"
                className="block body text-sm font-medium text-gray-700"
              >
                Your Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                className="mt-1 body block w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#AF313D]"
                placeholder="Your Message"
              />
              {errors.message && (
                <span className="text-red-500 text-xs">{errors.message}</span>
              )}
            </div>

            {/* Checkbox and Button */}
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              {/* Left side: Checkbox with text */}
              {/* <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="terms"
                  name="termsAccepted"
                  checked={formData.termsAccepted}
                  onChange={handleChange}
                  className="w-5 h-5 border-2 border-[#C97C2A] rounded-md focus:ring-[#AF313D] checked:bg-[#C97C2A] checked:border-[#C97C2A] accent-[#C97C2A]"
                />
                <label htmlFor="terms" className="text-lg font-medium">
                  I accept the{" "}
                  <span className="text-[#C97C2A] underline underline-offset-2">
                    Terms & Conditions
                  </span>
                </label>
              </div> */}

              {/* Right side: Send Message Button */}
              <button
                type="submit"
                className="w-full md:w-auto bg-[#AF313D] text-white h-14 rounded-full font-medium hover:bg-red-700 px-8 text-center"
              >
                <span className="body font-bold text-lg md:text-xl">
                  Send Message
                </span>
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
